export function videoCover() {
    return {
        _resizeHandler: null,

        init() {
            this.$nextTick(() => this.setWidth());

            let timeoutId;
            this._resizeHandler = () => {
                clearTimeout(timeoutId);
                timeoutId = setTimeout(() => this.setWidth(), 100);
            };
            window.addEventListener('resize', this._resizeHandler);
        },

        destroy() {
            window.removeEventListener('resize', this._resizeHandler);
        },

        setWidth() {
            const container = this.$refs.container;
            if (!container) return;

            const aspectRatio = container.offsetHeight / container.offsetWidth;
            const windowAspect = window.innerHeight / window.innerWidth;

            this.$el.style.width = windowAspect > aspectRatio
                ? `${(windowAspect / aspectRatio) * 100}%`
                : '100%';
            // this.$el.style.left = '50%';
            // this.$el.style.top = '50%';
            // this.$el.style.transform = 'translate(-50%, -50%)';
        },
    };
}
